const o = "_actionsRoot_vg43j_1", t = "_closeContainer_vg43j_17", n = {
  actionsRoot: o,
  closeContainer: t
};
export {
  o as actionsRoot,
  t as closeContainer,
  n as default
};
//# sourceMappingURL=index.es5745.js.map
